import { StandardEvents } from '@shopify/events';

// AG variant sync. Horizon fetches the product section on every variant change
// and hands the HTML to listeners via ProductSelectEvent. Any element with
// data-ag-variant-sync="<key>" is swapped for its counterpart in that HTML, so
// our own blocks (spec, back-in-stock, tiers) follow the selected variant
// without forking Horizon's picker.
document.addEventListener(StandardEvents.productSelect, async (event) => {
  if (event.target?.closest?.('product-card, ag-product-card')) return;
  try {
    const { detail } = await event.promise;
    const html = detail?.html;
    if (!html) return;
    document.querySelectorAll('[data-ag-variant-sync]').forEach((el) => {
      const key = el.getAttribute('data-ag-variant-sync');
      const fresh = html.querySelector(`[data-ag-variant-sync="${key}"]`);
      if (fresh) el.replaceWith(fresh.cloneNode(true));
    });
  } catch (e) { /* aborted fetch; ignore */ }
});
